import React, { useEffect, useState } from "react";
import "./PreOrders.css";
import Header from "../../../Layout/Header/Header";
import Footer from "../../../Layout/Footer/Footer";
import CustomOrderCard from "../../../CustomComponents/CustomOrderCard";
import { useDispatch } from "react-redux";
import {
  getAllOrderStatusAPI,
  getMyOrdersAPI,
} from "../../../../../Store/Action/orderAction";

import CustomLoader from "../../../CustomComponents/CustomLoader/CustomLoader";
import { getLoggedInUserDetailsAPI } from "../../../../../Store/Action/UserAction";
import EmptyOrder from "../MyOrders/EmptyOrder";
import { getWishlistAPI } from "../../../../../Store/Action/wishlistAction";

const PreOrders = () => {
  const dispatch = useDispatch();
  const [collapsedIndex, setCollapsedIndex] = useState(null);
  const [refreshState, setRefreshState] = useState(0);
  const [myOrders, setMyOrders] = useState([]);
  const [orderStatus, setOrderStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("preOrder");
  const [isWastageEnabled, setIsWastageEnabled] = useState(true);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setUserRole(result?.data?.[0]?.user_role_name);
        const booleanValue =
          result?.data?.[0]?.user_generic_data_value?.[0]
            ?.user_generic_data_boolean_value;
        setIsWastageEnabled(booleanValue === 1);
      })
    );
  }, [dispatch]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCollapsedIndex(null);
  };

  useEffect(() => {
    dispatch(
      getAllOrderStatusAPI({}, (result) => {
        setOrderStatus(result || []);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (!orderStatus?.length) return;
    setIsLoading(true);

    let filteredStatusIds = [];

    if (activeTab === "ongoing") {
      filteredStatusIds = orderStatus
        ?.filter(
          (s) =>
            !["delivered", "cancel", "return"].includes(
              s?.order_status_name?.toLowerCase()
            )
        )
        .map((s) => s.order_status_id);
    } else if (activeTab === "completed") {
      filteredStatusIds = orderStatus
        ?.filter((s) => s?.order_status_name?.toLowerCase() === "delivered")
        .map((s) => s.order_status_id);
    } else if (activeTab === "cancelReturn") {
      filteredStatusIds = orderStatus
        ?.filter((s) =>
          ["cancel", "return"].includes(s?.order_status_name?.toLowerCase())
        )
        .map((s) => s.order_status_id);
    }

    // dispatch(
    //   getMyOrdersAPI(
    //     { order_status_id: filteredStatusIds.join(",") },
    //     (result) => {
    //       setMyOrders(result?.data || []);
    //       setIsLoading(false);
    //     }
    //   )
    // );
    dispatch(
      getWishlistAPI({ flag_pre_order: true }, (result) => {

        setMyOrders(result?.data || []);
        setIsLoading(false);
      })
    );
  }, [dispatch, activeTab, refreshState, orderStatus]);

  const handleToggleCollapse = (index) => {
    setCollapsedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const onGetOrderList = () => {
    setRefreshState((prev) => prev + 1);
  };

  return (
    <>
      <Header />
      <div className="my-orders-div">
        <div className="order-account-header">
          <h3>My Orders</h3>
        </div>
        <div className="divider" />

        <div className="tab-buttons-pre" style={{ marginBottom: "20px" }}>
          <div
            className={`tab-button ${activeTab === "preOrder" ? "active" : ""}`}
            onClick={() => handleTabChange("preOrder")}
          >
            <p className="full-text">Pre Orders</p>
          </div>
        </div>

        {isLoading ? (
          <div className="loaderContainer">
            <CustomLoader />
          </div>
        ) : myOrders?.length === 0 ? (
          <EmptyOrder />
        ) : (
          <div className="my-orders-content-div">
            {myOrders?.map((order, index) => (
              <CustomOrderCard
                key={index}
                order={order}
                isCollapsed={collapsedIndex === index}
                onToggleCollapse={() => handleToggleCollapse(index)}
                activeTab={"preOrder"}
                isWastageEnabled={isWastageEnabled}
                isTrackOrderVisible={
                  order?.order_status_name?.toLowerCase() !== "pending" &&
                  order?.order_status_name?.toLowerCase() !==
                    "send to the manufacturer"
                }
                onGetOrderList={onGetOrderList}
              />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default PreOrders;
